// extracted by mini-css-extract-plugin
export var primitiveLabel = "_u4-0";